module.exports = __webpack_public_path__ + "static/media/marker_bed.99d0a28f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/markers/marker_bed.svg
// module id = 283
// module chunks = 0